'use client'

import { useEffect } from 'react'
import * as Sentry from '@sentry/nextjs'
import ServerError from '@/app/components/Layout/ServerError'

export default function Error({ error }) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <section className="flex items-center justify-center w-full py-24 overflow-hidden">
      <ServerError />
    </section>
  )
}
